import { render, staticRenderFns } from "./TheComputerLeaseAddForm.vue?vue&type=template&id=31b27745&"
import script from "./TheComputerLeaseAddForm.vue?vue&type=script&lang=js&"
export * from "./TheComputerLeaseAddForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports